/**
 * alias for request.js
 * @author luoying<luoying@szzbmy.com>
 * @since 18/11/16
 */
export * from './request';
//# sourceMappingURL=ajax.js.map